var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon-circle-fill_svg__circle-fill",
    strokeWidth: 0,
    fill: "currentColor",
    className: "SimpleAmenities___StyledIconCircleFill-sc-1uwbf9o-2 hzSusW",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.655 5.692c1.67-1.67 3.688-2.512 6.025-2.512 2.336 0 4.347.835 6.006 2.494 1.658 1.658 2.494 3.67 2.494 6.006 0 2.336-.836 4.347-2.494 6.006-1.659 1.658-3.67 2.494-6.006 2.494-2.337 0-4.348-.836-6.006-2.494-1.66-1.659-2.494-3.67-2.494-6.006 0-2.336.828-4.341 2.475-5.988z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.d4154cd6df318bd5fbba7821fba1cb88.svg";
export { ForwardRef as ReactComponent };